﻿import React, { useState, useRef, useEffect } from 'react';
import { paramsToObject } from '../../../../../Resources/Scripts/_Shared/history'
import { TwoColumnWrapper } from '../../../../../Resources/Scripts/_Shared/elements/ColumnWrapper'
import { DropdownlistWithLabel } from '../../../../../Resources/Scripts/_Shared/elements/DropdownlistWithLabel';
import { RadioButtonListWithLabel } from '../../../../../Resources/Scripts/_Shared/elements/RadioButtonListWithLabel';

const AdvFiltersWidget = ({ facilitySearchContext, setFacilitySearchContext }) => {
  const lang = {
    ...facilitySearchContext.localization.inputs,
    ...facilitySearchContext.localization.headings,
    ...facilitySearchContext.localization.filter
  };
  const [filterSelection, setFilterSelection] = useState(facilitySearchContext.filterSelection);
  const [currentServiceFilters, setCurrentServiceFilters] = useState([]);
  const [currentServiceFiltersOptions, setCurrentServiceFiltersOptions] = useState([]);
  const [currentParkingSpaceTypes, setCurrentParkingSpaceTypes] = useState([]);
  const [currentParkingSpaceTypesOptions, setCurrentParkingSpaceTypesOptions] = useState([]);
  const [filterSelected, setFilterSelected] = useState(false);
  const [bookingTypes, setBookingTypes] = useState(null);
  const [currentBookingType, setCurrentBookingType] = useState(null);
  const containerRef = useRef(null);
  const emptyGuid = '00000000-0000-0000-0000-000000000000';
  const selectValue = { item: { Text: 'Välj', Id: emptyGuid, initial: true } };
  const showDarkerTheme = facilitySearchContext.showDarkerNewStyle;

  useEffect(() => {
    if (facilitySearchContext.allFacilities && (filterSelected || facilitySearchContext.init)) {
      const searchHits = (FilterFacilities(facilitySearchContext.allFacilities, filterSelection));
      const delay = facilitySearchContext.init ? 500 : 0;
      setTimeout(() => { applyFiltersHandler(searchHits) }, delay);
    }
    handleScroll();
  }, [filterSelection])

  useEffect(() => {
    if (!facilitySearchContext.allFacilities || facilitySearchContext.allFacilities.length === 0) {
      const activeFilters = checkActiveFilters();
      const activeParkingFilters = checkActiveFilters(true);
      
      const tempFilterOptions = [];
      for (const [key] of Object.entries(filterSelection)) {
        const skip = (key === 'ParkingSpaceTypeSelection' || key === 'LTP' || key === 'STP' || (filterSelection.LTP && (key === 'disabled' || key === 'electricChargingPoint')));
        if (!skip && activeFilters.includes(key)) tempFilterOptions.push({ item: { Id: key, value: key, Text: (lang.services[key.toLowerCase()] || lang.info[key.charAt(0).toLowerCase() + key.slice(1)]).replace('&shy;', '') } });
      }
      const tempParkingOptions = activeParkingFilters.map(type => ({ item: { Id: type, value: type, Text: type } }));

      setCurrentServiceFilters(activeFilters);
      setCurrentParkingSpaceTypesOptions(tempParkingOptions);
      setCurrentServiceFiltersOptions(tempFilterOptions);
      setBookingTypes([{ value: 'LTP', id: 'LTP', Text: showDarkerTheme ? lang.info['LTP_alt'] : lang.info['LTP'].replace('&shy;', ''), disabled: true }, { value: 'STP', id: 'STP', Text: showDarkerTheme ? lang.info['STP_alt'] : lang.info['STP'].replace('&shy;', ''), disabled: true }]);
      return;
    }
    
    const uniqueServices = getUniqueServices();
    const parkingSpaceTypeSelection = [];

    for (const [key] of Object.entries(filterSelection.ParkingSpaceTypeSelection)) { filterSelection.ParkingSpaceTypeSelection[key] && parkingSpaceTypeSelection.push(key) };
    const [parkingSpaceTypes, parkingSpaceTypesAsObject] = setProductOptions();

    const stpOnly = facilitySearchContext.init && (uniqueServices.includes('STP') && !uniqueServices.includes('LTP'));
    setFilterSelected(false);
    setFilterSelection({ ...filterSelection, STP: stpOnly ? true : filterSelection.STP, LTP: stpOnly ? false : filterSelection.LTP, ParkingSpaceTypeSelection: { ...filterSelection.ParkingSpaceTypeSelection, ...parkingSpaceTypesAsObject } })
    setCurrentServiceFilters(uniqueServices);
    setCurrentParkingSpaceTypes(Array.from(new Set([...parkingSpaceTypeSelection, ...parkingSpaceTypes.flat()])));
  }, [facilitySearchContext.allFacilities])

  useEffect(() => {
    if (currentParkingSpaceTypes) setCurrentParkingSpaceTypesOptions(filterSelection.STP ? [] : currentParkingSpaceTypes.map(type => ({ item: { Id: type, value: type, Text: type } })));
    setCurrentBookingType({
      item:
        filterSelection.STP ? { value: 'STP', Id: 'STP', Text: lang.info['STP'].replace('&shy;', '') }
          : { value: 'LTP', Id: 'LTP', Text: lang.info['LTP'].replace('&shy;', '') }
    })
    const tempBookingTypes = [{ value: 'LTP', id: 'LTP', Text: showDarkerTheme ? lang.info['LTP_alt'] : lang.info['LTP'].replace('&shy;', ''), disabled: !currentServiceFilters.includes('LTP') }, { value: 'STP', Id: 'STP', Text: showDarkerTheme ? lang.info['STP_alt'] : lang.info['STP'].replace('&shy;', ''), disabled: !currentServiceFilters.includes('STP') }];
    setBookingTypes(tempBookingTypes)
    const tempOptions = [];

    for (const [key] of Object.entries(filterSelection)) {
      const skip = (key === 'ParkingSpaceTypeSelection' || key === 'LTP' || key === 'STP' || (filterSelection.LTP && (key === 'disabled' || key === 'electricChargingPoint')));
      if (!skip && (currentServiceFilters.includes(key) || filterSelection[key])) tempOptions.push({ item: { Id: key, value: key, Text: (lang.services[key.toLowerCase()] || lang.info[key.charAt(0).toLowerCase() + key.slice(1)]).replace('&shy;', '') } });
    }
    setCurrentServiceFiltersOptions(tempOptions);
  }, [currentParkingSpaceTypes])

  useEffect(() => {
    if (!currentBookingType || (!filterSelected && facilitySearchContext.init)) return;

    const STPselected = currentBookingType.item.value === 'STP';
    const filterItems = document.querySelectorAll('.facilitysearchpage__advfilters__filterlist li');
    const tempFilterSelection = { ...filterSelection, disabled: STPselected ? filterSelection.disabled : false, electricChargingPoint: STPselected ? filterSelection.electricChargingPoint : false, LTP: !STPselected, STP: STPselected, ParkingSpaceTypeSelection: STPselected ? {} : { ...filterSelection.ParkingSpaceTypeSelection } }
    const activeFilters = [...checkActiveFilters(false, null, tempFilterSelection), ...checkActiveFilters(true, null, tempFilterSelection)];

    filterItems.forEach(item => {
      const filterItem = item.querySelector('[data-value]') ? item.querySelector('[data-value]').dataset.value : null;
      if (filterItem && !activeFilters.includes(filterItem)) {
        item.classList.add('remove--red');
        item.classList.add('remove');
      }
    });

    const tempOptions = [];
    for (const [key] of Object.entries(tempFilterSelection)) {
      const skip = (key === 'ParkingSpaceTypeSelection' || key === 'LTP' || key === 'STP' || (tempFilterSelection.LTP && (key === 'disabled' || key === 'electricChargingPoint')));
      if (!skip && (currentServiceFilters.includes(key) || tempFilterSelection[key])) tempOptions.push({ item: { Id: key, value: key, Text: (lang.services[key.toLowerCase()] || lang.info[key.charAt(0).toLowerCase() + key.slice(1)]).replace('&shy;', '') } });
    }
    setTimeout(() => {
      setFilterSelection(tempFilterSelection)
      setCurrentServiceFiltersOptions(tempOptions);
      setCurrentParkingSpaceTypesOptions(tempFilterSelection.STP ? [] : currentParkingSpaceTypes.map(type => ({ item: { Id: type, value: type, Text: type } })));
    }, 200);
  }, [currentBookingType])

  const checkActiveFilters = (products, filterName, filters) => {
    const activeFilters = [];
    const tempFilterSelection = filters ? filters : { ...filterSelection };
    if (products) for (const [key] of Object.entries(tempFilterSelection.ParkingSpaceTypeSelection)) { 
      if (tempFilterSelection.ParkingSpaceTypeSelection[key] && (!filterName || key !== filterName)) activeFilters.push(key) 
    }
    else for (const [key] of Object.entries(tempFilterSelection)) { 
      const skip = (key === 'ParkingSpaceTypeSelection' || (filterSelection.LTP && (key === 'disabled' || key === 'electricChargingPoint')));
      if (tempFilterSelection[key] && !skip && (!filterName || key !== filterName)) activeFilters.push(key) 
    };
    return activeFilters;
  }

  const applyFiltersHandler = (searchHits) => {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.delete('f');
    urlParams.delete('p');
    const filters = checkActiveFilters(false, null, filterSelection);
    const parkingFilters = checkActiveFilters(true, null, filterSelection);
    const updateMapBounds = !!((getNumberOfFilters(filterSelection) - 1) || getNumberOfFilters(filterSelection.ParkingSpaceTypeSelection) || !facilitySearchContext.init);
    if (filters.length) urlParams.set('f', filters.join(','));
    if (parkingFilters.length) urlParams.set('p', parkingFilters.join(','))
    const newUrl = location.origin + window.location.pathname + '?' + urlParams.toString();
    history.pushState(paramsToObject(urlParams), document.title, newUrl);
    if (searchHits.length) setFacilitySearchContext({ ...facilitySearchContext, setListEmpty: false, filtersOpen: false, filterSelection: { ...filterSelection }, visibleFacilities: searchHits, filteredFacilities: searchHits, updateMapBounds, updateMarkers: true, init: false });
    else setFacilitySearchContext({ ...facilitySearchContext, setListEmpty: true, filterSelection, filteredFacilities: searchHits, visibleFacilities: [], updateMapBounds: false, updateMarkers: true, init: true, showLoadingScreen: false });
  };

  const setProductOptions = () => {
    const parkingSpaceTypes = [];
    const parkingSpaceTypesAsObject = {};
    for (let i = 0; i < facilitySearchContext.allFacilities.length; i++) {
      const singleFacility = facilitySearchContext.allFacilities[i];
      let singleParkingSpaceTypes = singleFacility.ParkingZones.map(zone => zone.Pmcs && zone.Pmcs.map(pmc => pmc.ParkingSpaceType))[0];
      singleParkingSpaceTypes = singleParkingSpaceTypes ? singleParkingSpaceTypes.filter(Boolean) : [];
      if (singleParkingSpaceTypes) parkingSpaceTypes.push(...singleParkingSpaceTypes)
    }
    if (parkingSpaceTypes && parkingSpaceTypes.length) Array.from(new Set(parkingSpaceTypes.filter(Boolean).flat())).forEach(type => parkingSpaceTypesAsObject[type] = filterSelection.ParkingSpaceTypeSelection[type] ? filterSelection.ParkingSpaceTypeSelection[type] : false)

    return [parkingSpaceTypes, parkingSpaceTypesAsObject];
  }

  const getUniqueServices = () => {
    const uniqueServices = [];
    for (let i = 0; i < facilitySearchContext.allFacilities.length; i++) {
      const singleFacility = facilitySearchContext.allFacilities[i];
      const facilityServices = singleFacility.Services;
      //singleParkingSpaceTypes = singleParkingSpaceTypes.length > 0 && Array.from(new Set(singleParkingSpaceTypes));

      const facilityInfo = {
        Indoor: singleFacility.Indoor,
        Outdoor: !singleFacility.Indoor,
        LTP: singleFacility.HasLtp,
        STP: singleFacility.HasStp,
        ...singleFacility.Info
      };

      if (facilityInfo.LTP || facilityInfo.STP) {
        for (let x = 0; x < facilityServices.length; x++) {
          var singleService = facilityServices[x];
          if (uniqueServices.filter(service => service === singleService).length === 0)
            uniqueServices.push(singleService);
        }

        for (const [key] of Object.entries(facilityInfo)) {
          if (facilityInfo[key] && key !== 'type' && !uniqueServices.includes(key)) uniqueServices.push(key);
        }
      }
    }
    return uniqueServices;
  }

  const removeServiceItem = (e) => {
    setFilterSelected(true);
    const filterName = e.currentTarget.dataset.value;
    e.currentTarget.closest('li').classList.add('remove');
    const activeFilters = checkActiveFilters(false, filterName);
    const tempOptions = [];
    const tempFilterSelection = { ...filterSelection, [filterName]: false };
    const tempServiceFilters = [...getUniqueServices(), ...activeFilters];
    for (const [key] of Object.entries(tempFilterSelection)) {
      const skip = (key === 'ParkingSpaceTypeSelection' || key === 'LTP' || key === 'STP' || (filterSelection.LTP && (key === 'disabled' || key === 'electricChargingPoint')));
      if (!skip && (tempServiceFilters.includes(key) || tempFilterSelection[key])) tempOptions.push({ item: { Id: key, value: key, Text: (lang.services[key.toLowerCase()] || lang.info[key.charAt(0).toLowerCase() + key.slice(1)]).replace('&shy;', '') } });
    }
    setTimeout(() => {
      setFilterSelection({ ...filterSelection, [filterName]: false })
      setCurrentServiceFilters([...getUniqueServices(), ...activeFilters]);
      setCurrentServiceFiltersOptions(tempOptions);
    }, 200)
  }

  const removeParkingspaceTypeItem = (e) => {
    setFilterSelected(true);
    const filterName = e.currentTarget.dataset.value;
    e.currentTarget.closest('li').classList.add('remove');
    const [parkingSpaceTypes, parkingSpaceTypesAsObject] = setProductOptions();
    const activeFilters = checkActiveFilters(true, filterName);
    const dublicatesRemoved = Array.from(new Set([...parkingSpaceTypes, ...activeFilters]));
    const tempOptions = dublicatesRemoved.map(type => ({ item: { Id: type, value: type, Text: type } }));
    setTimeout(() => {
      setFilterSelection({ ...filterSelection, ParkingSpaceTypeSelection: { ...filterSelection.ParkingSpaceTypeSelection, [filterName]: false } })
      setCurrentParkingSpaceTypesOptions(filterSelection.STP ? [] : tempOptions);
    }, 200)
  }

  const overflowLeftOrRight = () => {
    const edges = ['left', 'right'];
    if (containerRef.current) {
      const { current } = containerRef;
      if (current.scrollLeft <= 5) edges[0] = null;
      if (current.offsetWidth !== 0 && Math.abs(current.scrollWidth - current.clientWidth - current.scrollLeft) <= 5) edges[1] = null;
      if (current.offsetWidth !== 0 && current.offsetWidth >= current.scrollWidth) edges[0] = edges[1] = null;
    }
    return edges;
  };

  const handleScroll = () => {
    const wrapper = containerRef.current.parentNode;
    const edges = overflowLeftOrRight();
    wrapper.querySelectorAll('.shadow').forEach(shadow => shadow.classList.remove('visible'));
    edges.forEach(edge => { if (edge) wrapper.querySelector(`.shadow--${edge}`).classList.add('visible') });
  };

  const getNumberOfFilters = (object) => {
    return Object.values(object).reduce((a, item) => a + (item === true ? 1 : 0), 0);
  }

  return (
    <>
      <TwoColumnWrapper>
        <TwoColumnWrapper>
          {currentBookingType && <RadioButtonListWithLabel value={currentBookingType} options={bookingTypes} setValue={(value) => { setFilterSelected('bookingtype'); setCurrentBookingType(value); }} />}
        </TwoColumnWrapper>
        <TwoColumnWrapper>
          <DropdownlistWithLabel text={showDarkerTheme ? lang.filterfeature : lang.filter} value={{ item: { ...selectValue.item, Text: `${getNumberOfFilters(filterSelection) > 1 ? '(' + (getNumberOfFilters(filterSelection) - 1) + ')' : ''} ${lang.select}` } }} options={currentServiceFiltersOptions} setValue={(option) => { setFilterSelection({ ...filterSelection, [option.item.item.value]: true }); setFilterSelected(true) }} />
          {currentParkingSpaceTypesOptions.length > 0 && <DropdownlistWithLabel text={lang.product} value={{ item: { ...selectValue.item, Text: `${getNumberOfFilters(filterSelection.ParkingSpaceTypeSelection) ? '(' + getNumberOfFilters(filterSelection.ParkingSpaceTypeSelection) + ')' : ''} ${lang.select}` } }} options={currentParkingSpaceTypesOptions} setValue={(option) => { setFilterSelection({ ...filterSelection, ParkingSpaceTypeSelection: { ...filterSelection.ParkingSpaceTypeSelection, [option.item.item.value]: true } }); setFilterSelected(true) }} />}        </TwoColumnWrapper>
      </TwoColumnWrapper>
      <div className="facilitysearchpage__advfilters__filterlist__wrapper">
        <span className='shadow shadow--left'></span><span className='shadow shadow--right'></span>
        <ul ref={containerRef} onScroll={handleScroll} className="facilitysearchpage__advfilters__filterlist">{currentServiceFiltersOptions.length ? currentServiceFiltersOptions.map(filter => {
          if (filter.item.value === 'STP' || filter.item.value === 'LTP') return null;
          return filterSelection[filter.item.value] && (<li key={filter.item.value}><span>{filter.item.Text}</span><div className="close" onClick={removeServiceItem} data-value={filter.item.value}><span></span><span></span></div></li>)
        }) : null}
          {currentParkingSpaceTypesOptions.length ? currentParkingSpaceTypesOptions.map(filter => {
            return filterSelection.ParkingSpaceTypeSelection[filter.item.value] && (<li key={filter.item.value}><span>{filter.item.Text}</span><div className="close" onClick={removeParkingspaceTypeItem} data-value={filter.item.value} data-product={true}><span></span><span></span></div></li>)
          }) : null}
        </ul>
      </div>
    </>
  )
}

export const FilterFacilities = (allFacilities, filterSelection) => {
  const flatFilterSelection = [];
  const matchingFacilities = [];
  for (const [key, value] of Object.entries(filterSelection)) {
    if (value && key !== 'distance' && key !== 'ParkingSpaceTypeSelection')
      flatFilterSelection.push(key);
  }
  if (filterSelection.ParkingSpaceTypeSelection) {
    for (const [key, value] of Object.entries(filterSelection.ParkingSpaceTypeSelection)) {
      if (value)
        flatFilterSelection.push(key);
    }
  }

  for (let i = 0; i < allFacilities.length; i++) {
    const singleFacility = allFacilities[i];
    const singleFacilityServices = singleFacility.Services ? singleFacility.Services.map(service => service.charAt(0).toLowerCase() + service.slice(1)) ?? [] : singleFacility.Services;
    let singleParkingSpaceTypes = singleFacility.ParkingZones.map(zone => zone.Pmcs && zone.Pmcs.map(pmc => pmc.ParkingSpaceType))[0];
    singleParkingSpaceTypes = singleParkingSpaceTypes ? singleParkingSpaceTypes.filter(Boolean) : [];
    singleParkingSpaceTypes = singleParkingSpaceTypes.length > 0 && Array.from(new Set(singleParkingSpaceTypes));

    const parkingSpaceTypesAsObject = {};

    if (singleParkingSpaceTypes && singleParkingSpaceTypes.length) Array.from(new Set(singleParkingSpaceTypes.filter(Boolean).flat())).forEach(type => parkingSpaceTypesAsObject[type] = true)

    const singleFacilityInfo = {
      Indoor: singleFacility.Indoor,
      Outdoor: !singleFacility.Indoor,
      LTP: singleFacility.HasLtp,
      STP: singleFacility.HasStp,
      ...singleFacility.Info,
      ...parkingSpaceTypesAsObject
    };

    const matchCount = [
      ...singleFacilityServices.filter(service => flatFilterSelection.includes(service)),
      ...flatFilterSelection.filter(filter => singleFacilityInfo[filter] && ((filter === 'MaxVehicleHeight' && singleFacilityInfo[filter] > 200) || filter !== 'MaxVehicleHeight'))
    ];

    if (flatFilterSelection.length === Array.from(new Set(matchCount)).length)
      matchingFacilities.push(singleFacility);
  }
  return matchingFacilities;

}
export default AdvFiltersWidget;
